// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InsTgTkl3D1m4v {
  margin-top: var(--ds-space-200, 16px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  display: block;
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-100, 8px);
}
.dbb2vifxXFgqzD {
  display: inline-flex;
  flex-wrap: wrap;
  max-width: 250px;
}
.WqHg8CTBF7Vsap {
  margin: var(--ds-space-0, 0) var(--ds-space-025, 2px) var(--ds-space-050, 4px) var(--ds-space-0, 0);
  background-color: unset;
}
.WqHg8CTBF7Vsap:hover {
  background-color: unset;
}
.FQkSYzwELdoYww {
  margin-bottom: var(--ds-space-100, 8px);
}
.rYj_FR3U5mYy5Z {
  background-color: var(--ds-background-neutral, #091e420f);
  display: block;
  margin-bottom: var(--ds-space-150, 10px);
  border-radius: var(--ds-border-radius-100, 3px);
  color: var(--ds-text-subtle, #44546f);
  text-align: center;
}
.rYj_FR3U5mYy5Z a {
  color: var(--ds-link, #0c66e4);
}
.rYj_FR3U5mYy5Z p {
  padding: var(--ds-space-300, 24px) var(--ds-space-075, 6px);
}
.LQmx9_JEl_DQSZ {
  padding-left: var(--ds-space-075, 5px);
}
`, ""]);
// Exports
export var sectionHeader = `InsTgTkl3D1m4v`;
export var avatarList = `dbb2vifxXFgqzD`;
export var avatarContainer = `WqHg8CTBF7Vsap`;
export var textfield = `FQkSYzwELdoYww`;
export var noResults = `rYj_FR3U5mYy5Z`;
export var shareLink = `LQmx9_JEl_DQSZ`;
export default ___CSS_LOADER_EXPORT___;
